import {
    AddProductPayload,
    BuyBookingPayload,
    BuyProductPayload,
} from '../types/EcomSDK';

const waitUntilEcomSDKIsReady = async () => {
    if (!window._ecomSDK) {
        throw new Error('_ecomSDK is not defined');
    }
    await window._ecomSDK.ready;
};

export const buyBooking = async (payload: BuyBookingPayload) => {
    await waitUntilEcomSDKIsReady();
    return await window._ecomSDK!.buyBooking(payload);
};

export const addProduct = async (payload: AddProductPayload) => {
    await waitUntilEcomSDKIsReady();
    return await window._ecomSDK!.addProduct(payload);
};

export const buyProduct = async (payload: BuyProductPayload) => {
    await waitUntilEcomSDKIsReady();
    return await window._ecomSDK!.buyProduct(payload);
};
